jQuery(document).ready(function($) {
	function toggle() {
		$(this).parents('.toggle-wrapper').toggleClass('active');
		if ($('.toggle-wrapper').hasClass('active')) {
			$('.toggle-wrapper').show();
		} else {
			$('.toggle-wrapper').fadeOut('slow', function() {
				$(this).hide();
			});
		}
	}
	$('.toggle').on('click', toggle);
});
